import React, { useEffect, useState } from 'react';

import { gql } from '@apollo/client';
import { Create, SaveButton, SimpleForm, TextInput, Toolbar, useAuthState, useRedirect } from 'react-admin';

import { HiddenField } from 'dash/shared';
import PubSub from 'pubsub-js';
import AppState from 'shared/app_state';
import { parseURLParams } from 'shared/helpers';
import { AccountScoped } from 'shared/react-admin';
import { Form } from 'shared/types';

export const FETCH_FORM_TEMPLATES = gql`
  query {
    formTemplates {
      id
      name
      source
      description
    }
  }
`;

const DEFAULT_FORM_SRC = '// Type your fields here...\n\nname,email';

const FormCreateToolbar = props => {
  const redirect = useRedirect()

  return (
  <Toolbar {...props} >
    <SaveButton
      label="Create"
      mutationOptions={{
        onSuccess: (data) => {
          PubSub.publish('form/create')
          redirect(`/account/${AppState.getCurrentAccount().id}/services/form/${data.id}/entries`)
        }
      }}
      type="button"
    />
  </Toolbar>
  )
}

export const FormCreate = (props) => {
  // Below sourceURLParam are just used to see iff form template select input should be rendered
  // Don't need to explicitly pass sourceURLParams through because react-admin does
  // this automatically https://marmelab.com/react-admin/CreateEdit.html#prefilling-a-create-record
  const [sourceURLParam] = useState<string>(parseURLParams([{ key: 'source' }]).source);

  // const { data, loading, error } = useQuery(FETCH_FORM_TEMPLATES);

  const { isLoading: authStateLoading, authenticated } = useAuthState();

  const parseLastDashPage = (url: string): string => {
    const [domain, path] = url.split('/dash#');
    return path;
  };

  useEffect(() => {
    // TODO refactor redirects for more general case
    // currently, this is a special case to enable deep links from external apps
    // where the user needs to login or create an account
    if (!authStateLoading) {
      if (!authenticated && !!sourceURLParam) AppState.setLastPage(parseLastDashPage(window.location.href));
      else if (!!AppState.getLastPage()) AppState.resetLastPage(); // clear on authed reload
    }
  }, [authStateLoading, authenticated]);

  const ensureSourceSet = (data: Form): Form => {
    // https://marmelab.com/react-admin/CreateEdit.html#transform

    if (!data.source || data.source == '') data.source = DEFAULT_FORM_SRC;
    return data;
  };

  // if (error) {
  //   console.log('error fetching form templates', error);
  //   return null;
  // }

  // if (loading) return null;

  return (
    <AccountScoped view="Form Create" componentProps={props}>
      {(accountId: string) => (
        <Create
          transform={ensureSourceSet}
          redirect={(resource, id) => `${resource}/${id}/entries`}
        >
          <SimpleForm
            toolbar={<FormCreateToolbar />}
          >
            <TextInput autoFocus source="name" label="Form Title" fullWidth placeholder='A friendly name for your new form' />
            {/* {!sourceURLParam && (
              <>
                <div style={{
                  marginBottom: 18
                }}>
                  <Typography variant="h6" component="h3">
                    Template
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    You can build your form from scratch, or use one of our predefined templates.
                  </Typography>
                </div>
                <GridSelect {...props} source="source" data={data} />
              </>
            )} */}
            <HiddenField source="accountId" value={accountId} />
          </SimpleForm>
        </Create>
      )}
    </AccountScoped>
  );
};
